import { createFileRoute } from '@tanstack/react-router';

import { BookmarksPage } from '../../pages/bookmarks';

export const Route = createFileRoute('/_shell/bookmarks')({
  component: BookmarksPage,
});
